(function () {
	const DPD = {
		TEMPLATE_CLASS: 'dpd-parcelshop-container',
		TEMPLATE_SOURCE_ID: 'dpd-template-source',
		RADIO_SELECTOR: 'input[type="radio"][id*="wc_dpd_parcelshop"]',
		DESCRIPTION_CART_GROUP_SELECTOR:
			'.wc-block-components-radio-control__description-group',
		DESCRIPTION_CHECKOUT_GROUP_SELECTOR:
			'.wc-block-components-radio-control__option-layout',
		HIDDEN_INPUT_SELECTOR: 'input[type="hidden"]',
		CHOSEN_CONTENT_SELECTOR: '.js-dpd-chosen-parcelshop-content',
		CHOSEN_TEXT_SELECTOR: '.js-dpd-chosen-parcelshop-chosen-parcelshop-text',
	};

	let addTemplatesScheduled = false;

	function findDpdRadios() {
		const selectors = [
			'input[type="radio"][id*="wc_dpd_parcelshop"]',
			'input[type="radio"][value*="dpd_parcelshop"]',
			'input[type="radio"][name*="dpd_parcelshop"]',
		];

		const allRadios = [];
		selectors.forEach((selector) => {
			const radios = document.querySelectorAll(selector);
			if (radios.length > 0) {
				Array.prototype.push.apply(allRadios, radios);
			}
		});

		return allRadios;
	}

	/**
	 * Clone the footer template under every DPD rate that does not have it yet.
	 *
	 * Safe to call any number of times: rates that already carry a clone are
	 * skipped.
	 */
	function addTemplates() {
		const radios = findDpdRadios();
		if (radios.length === 0) {
			return;
		}

		// Get template content from the hidden div
		const templateSource = document.getElementById(DPD.TEMPLATE_SOURCE_ID);
		if (!templateSource) {
			console.error('DPD Parcelshop template source not found');
			return;
		}

		const templateContent = templateSource.innerHTML;
		if (!templateContent) {
			console.error('DPD Parcelshop template content not available');
			return;
		}

		radios.forEach((radio) => {
			const container = radio.closest(
				'.wc-block-components-radio-control__option'
			);
			if (!container) return;

			const descCartGroup = container.querySelector(
				DPD.DESCRIPTION_CART_GROUP_SELECTOR
			);
			const descCheckoutGroup = container.querySelector(
				DPD.DESCRIPTION_CHECKOUT_GROUP_SELECTOR
			);
			if (!descCartGroup && !descCheckoutGroup) return;

			if (
				descCartGroup &&
				descCartGroup.querySelector('.' + DPD.TEMPLATE_CLASS)
			)
				return;
			if (
				descCheckoutGroup &&
				descCheckoutGroup.querySelector('.' + DPD.TEMPLATE_CLASS)
			)
				return;

			const template = document.createElement('div');
			template.className = DPD.TEMPLATE_CLASS;
			template.innerHTML = templateContent;

			if (descCartGroup) {
				descCartGroup.appendChild(template);
			}

			if (descCheckoutGroup) {
				descCheckoutGroup.appendChild(template);
			}
		});
	}

	function scheduleAddTemplates() {
		if (addTemplatesScheduled) {
			return;
		}

		addTemplatesScheduled = true;
		setTimeout(function () {
			addTemplatesScheduled = false;
			addTemplates();
		}, 0);
	}

	/**
	 * Return the clone inside a removed node, or null.
	 */
	function findClone(node) {
		if (!node || node.nodeType !== 1) {
			return null;
		}

		if (node.classList && node.classList.contains(DPD.TEMPLATE_CLASS)) {
			return node;
		}

		return node.querySelector ? node.querySelector('.' + DPD.TEMPLATE_CLASS) : null;
	}

	/**
	 * Copy the parcelshop chosen in a clone into the footer template.
	 *
	 * The map and popup scripts write the choice into the first matching hidden
	 * inputs and text, which is the clone, never the template. A clone made
	 * again after a re-render would otherwise show the parcelshop from page
	 * load. innerHTML carries attributes, not live input values, so the values
	 * are written as attributes.
	 */
	function syncTemplateFrom(clone) {
		const templateSource = document.getElementById(DPD.TEMPLATE_SOURCE_ID);
		if (!templateSource) {
			return;
		}

		clone.querySelectorAll(DPD.HIDDEN_INPUT_SELECTOR).forEach((input) => {
			const name = input.getAttribute('name');
			if (!name) return;

			const target = templateSource.querySelector(
				DPD.HIDDEN_INPUT_SELECTOR + '[name="' + name + '"]'
			);
			if (target) {
				target.setAttribute('value', input.value);
			}
		});

		const text = clone.querySelector(DPD.CHOSEN_TEXT_SELECTOR);
		const templateText = templateSource.querySelector(DPD.CHOSEN_TEXT_SELECTOR);
		if (text && templateText) {
			templateText.innerHTML = text.innerHTML;
		}

		const content = clone.querySelector(DPD.CHOSEN_CONTENT_SELECTOR);
		const templateContent = templateSource.querySelector(
			DPD.CHOSEN_CONTENT_SELECTOR
		);
		if (content && templateContent) {
			if (content.classList.contains('active')) {
				templateContent.classList.add('active');
			} else {
				templateContent.classList.remove('active');
			}
		}
	}

	/**
	 * Put the clone back whenever the checkout re-renders the shipping rates.
	 *
	 * Every shipping-address change re-renders the rate list, and the clone,
	 * which the block checkout does not know about, goes with it. The template
	 * used to be cloned once, so after any address change the customer had DPD
	 * selected but no button to choose a parcelshop until a reload.
	 * This also replaces polling for the first DPD rate to appear.
	 */
	function watchForRerenders() {
		if (typeof MutationObserver === 'undefined' || !document.body) {
			return;
		}

		new MutationObserver(function (mutations) {
			mutations.forEach(function (mutation) {
				Array.prototype.forEach.call(mutation.removedNodes, function (node) {
					const clone = findClone(node);
					if (clone) {
						syncTemplateFrom(clone);
					}
				});
			});

			scheduleAddTemplates();
		}).observe(document.body, { childList: true, subtree: true });
	}

	function initialize() {
		// Check if we should run (set by wp_localize_script)
		if (
			typeof wc_dpd_parcelshop_block_settings === 'undefined' ||
			!wc_dpd_parcelshop_block_settings.ready
		) {
			return;
		}

		addTemplates();
		watchForRerenders();
	}

	if (document.readyState === 'loading') {
		document.addEventListener('DOMContentLoaded', initialize);
	} else {
		initialize();
	}
})();
